import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import PropTypes from 'prop-types';

export const DialogConfirmCancelEditTicket = (props) => {
    const { detailTicket, handleResetFormData, setCloseTabIdState, handleCancelTicket, isConfirmCancelEditTicket} = props;

    // Cancel
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmCancelEditTicket(false);
        setCloseTabIdState(0)
    };

    // Handle save draft
    const handlerClearDraft = () => {
        props.setIsConfirmCancelEditTicket(false);
        handleResetFormData();
    }

    return (
        <Dialog
            open={isConfirmCancelEditTicket}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {I18n.get('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={() => {
                        if (detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC) {
                            handleCancelTicket()
                            return;
                        }
                        if (detailTicket.public === Constant.TICKET_PUBLIC.DRAFT) {
                            handlerClearDraft();
                            return;
                        }
                    }}
                >
                    {I18n.get('CM-BUTTON-OK')}
                </Button>

               <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('CM-BUTTON-CANCEL')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirmCancelEditTicket.propTypes = {
    detailTicket: PropTypes.object,
    handleResetFormData: PropTypes.func,
    setCloseTabIdState: PropTypes.func,
    isConfirmCancelEditTicket: PropTypes.bool,
    handleCancelTicket: PropTypes.func
}